import { mutationTypesSlideOuts } from '@/store/modules/slide-outs/types'

export default {
    [mutationTypesSlideOuts.SET_SELECTED_SLIDE_OUT]: (state, payload) => {
        const { slideOutComponent, props } = payload
        state.selectedComponent = slideOutComponent
        state.props = props
    },
}
